import { useTranslation } from 'react-i18next'
import { useFormikContext } from 'formik'

import { useScreen } from '../../../../../hooks'
import { BuildingSelect } from '../../../../Building'
import { FormFieldSelectNG } from '../../../../Form'
import { FormikField, getFormikFormFieldErrorProps } from '../../../../Formik'
import {
  USER_FORM_FIELD_NAME_BUILDING,
  USER_FORM_FIELD_NAME_FLAT,
} from '../../../../User'

function BuildingField({ apiParams }) {
  const { t } = useTranslation()

  const { setFieldValue } = useFormikContext()

  const { isMobileScreenSize } = useScreen()

  function handleClear() {
    setFieldValue(USER_FORM_FIELD_NAME_FLAT, null)
  }

  return (
    <FormikField
      Component={FormFieldSelectNG}
      Select={BuildingSelect}
      apiParams={apiParams}
      controlProps={{
        borderless: !isMobileScreenSize,
        contentProps: {
          inputProps: {
            placeholder: t('Inhabitant.BuildingPlaceholderKey'),
          },
        },
      }}
      emptyValue={null}
      fieldComponentProps={{
        label: `${t('Inhabitant.BuildingLabelKey')}:`,
        required: true,
        shouldAdaptToMobileScreen: true,
      }}
      getErrorProps={getFormikFormFieldErrorProps}
      name={USER_FORM_FIELD_NAME_BUILDING}
      onClear={handleClear}
    />
  )
}

export default BuildingField
